import nextId from "react-id-generator"
import quote from "../../images/double-quotes.svg"
import geek1 from "../../images/geek.jpg"
import geek2 from "../../images/geek2.jpg"
import geek3 from "../../images/geek3.jpg"
import geek4 from "../../images/geek4.jpg"

export const slides = [
    {
        id: nextId(),
        quote: quote,
        description: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente et non deserunt vel eos cum earum quaerat nihil odio suscipit. Laudantium nihil autem excepturi fugit eaque corrupti perferendis totam unde!",
        date: "July 05. 2022",
        image: geek1,
        name: "John Doe",
        detail: "Director of a company"
    },
    {
        id: nextId(),
        quote: quote,
        description: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente et non deserunt vel eos cum earum quaerat nihil odio suscipit. Laudantium nihil autem excepturi fugit eaque corrupti perferendis totam unde!",
        date: "July 05. 2022",
        image: geek2,
        name: "John Doe",
        detail: "Director of a company"
    },
    {
        id: nextId(),
        quote: quote,
        description: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente et non deserunt vel eos cum earum quaerat nihil odio suscipit. Laudantium nihil autem excepturi fugit eaque corrupti perferendis totam unde!",
        date: "July 05. 2022",
        image: geek3,
        name: "John Doe",
        detail: "Director of a company"
    },
    {
        id: nextId(),
        quote: quote,
        description: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente et non deserunt vel eos cum earum quaerat nihil odio suscipit. Laudantium nihil autem excepturi fugit eaque corrupti perferendis totam unde!",
        date: "July 05. 2022",
        image: geek4,
        name: "John Doe",
        detail: "Director of a company"
    },
]